import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createTaskStatusAsync, updateTaskStatusAsync, selectTaskStatusBySqId } from '../../slice/taskStatusSlice';
import {ReactComponent as OK} from '../../assets/ok.svg';
import { useThemeColor } from '../../hooks/useThemeColor';

const SQ = ({ question, index, onDescriptionSelect, historyId, isActive = false }) => {
    const dispatch = useDispatch();
    const taskStatus = useSelector(state => selectTaskStatusBySqId(state, question?.id, historyId));
    const { primaryColor } = useThemeColor();

    const handleClick = () => {
        onDescriptionSelect(question);
        
        // Create or update task status
        const taskStatusData = {
            history_id: historyId,
            sq_id: question?.id,
            status: true
        };

        if (taskStatus) {
            dispatch(updateTaskStatusAsync(taskStatusData));
        } else {
            dispatch(createTaskStatusAsync(taskStatusData));
        }
    };

    return (
        <div 
            onClick={handleClick} 
            className={`cursor-pointer p-5 rounded flex flex-col gap-3 ${
                (isActive || taskStatus?.status)
                    ? 'bg-custom-yellow/50 border border-custom-yellow'
                    : 'bg-custom-gray_white'
            }`}
            data-active={isActive ? 'true' : 'false'}
            id={`question-${question?.id}`}
        >
            <div className='flex justify-between items-center'>
                <h1 className='text-lg font-semibold text-black'>
                    {question?.title}
                </h1>
                <div className={taskStatus?.status ? 'text-custom-yellow' : 'text-[#5F6368]'}>
                    <OK className="w-6 h-6" />
                </div>
            </div>
            <p className='text-gray-500 max-w-sm'>
                {question?.description}
            </p>
        </div>
    );
};

export default SQ;